import React from 'react';
import './Toggle.css';

export interface ToggleProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
    size?: 'sm' | 'md' | 'lg';
    disabled?: boolean;
}

const Toggle: React.FC<ToggleProps> = ({
    checked,
    onChange,
    label,
    size = 'md',
    disabled = false
}) => {
    return (
        <label className={`toggle toggle--${size} ${disabled ? 'toggle--disabled' : ''}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
                className="toggle__input"
            />
            <span className="toggle__slider"></span>
            {label && <span className="toggle__label">{label}</span>}
        </label>
    );
};

export default Toggle;
